import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-137" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-138" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7-day satisfaction guarantee" data-id="element-139" data-mp="222wjc7wug0nm">
          <defs data-id="element-140" data-mp="19e7m4jywsfh5">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-141" data-mp="19fsj0g8p4ai6" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-142" data-mp="14h8ty6yt2ill" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-143" data-mp="1j6501yhaxljk" />
          <text fill="currentColor" fontSize="12.5" fontWeight="700" letterSpacing="1.5" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-144" data-mp="1ec98pevjmwxd">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-145" data-mp="lp6aknus4o7n">
              SATISFACTION GUARANTEE · HOCKEY READY ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-146" data-mp="oxp1i0q6f2zu">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-147" data-mp="yqe220k6uwge">
            DAYS
          </text>
        </svg>

        <div data-id="element-148" data-mp="628gxcp835g1">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-149" data-mp="62qkkue7slxz">
            7-Day Satisfaction Guarantee
          </h2>
          <p className="mt-3 font-serif text-2xl italic leading-snug text-red-700" data-id="element-150" data-mp="f0ak9ywfia6h">
            Explore Your Season Plan with Confidence.
          </p>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-151" data-mp="jy2fb1sdecew">
            Open the volumes and see how they work for your team. If the bundle doesn’t meet your
            expectations, email us to request a refund within 7 days of purchase, according to our
            guarantee terms.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-152" data-mp="3nhob3u322lm1">
            This guarantee does not affect your rights under applicable consumer law.
          </p>
        </div>
      </div>
    </section>;
}